import { WORDPRESS_API } from "shared/constants";


export const normalizeWordPressUrl = (url) => {
  if (!url) {
    return null;
  }

  try {
    const sourceUrl = new URL(url);
    const currentWordPressUrl = new URL(WORDPRESS_API);

    return `${currentWordPressUrl.origin}${sourceUrl.pathname}${sourceUrl.search}${sourceUrl.hash}`;
  } catch {
    return url;
  }
};


export const normalizeWordPressHtml = (html = "") => {
  if (!html) {
    return "";
  }

  try {
    const container = document.createElement("div");

    container.innerHTML = html;

    const currentWordPressUrl =
      new URL(WORDPRESS_API);

    const normalizeAttribute = (
      element,
      attribute
    ) => {
      const value =
        element.getAttribute(attribute);

      if (!value) {
        return;
      }

      try {
        const sourceUrl =
          new URL(value, currentWordPressUrl.origin);

        if (
          sourceUrl.pathname.startsWith(
            "/wp-content/"
          ) ||
          sourceUrl.pathname.startsWith(
            "/wp-includes/"
          )
        ) {
          element.setAttribute(
            attribute,
            `${currentWordPressUrl.origin}${sourceUrl.pathname}${sourceUrl.search}${sourceUrl.hash}`
          );
        }
      } catch {
        // zostawiamy oryginalną wartość
      }
    };

    container
      .querySelectorAll("[src]")
      .forEach((element) => {
        normalizeAttribute(
          element,
          "src"
        );
      });

    container
      .querySelectorAll("[href]")
      .forEach((element) => {
        normalizeAttribute(
          element,
          "href"
        );
      });

    return container.innerHTML;
  } catch {
    return html;
  }
};